import {fromUnixTimeFormat} from "../../../shared/utils/dayjsUtil";
import {getItemName} from "../../../shared/utils/basic";

const parseLogData = (logString, record) => {
    if (!record.parsedLogData) {
        try {
            record.parsedLogData = JSON.parse(logString);
        } catch (error) {
            console.error('logString 파싱 오류:', error);
            record.parsedLogData = {};
        }
    }
    return record.parsedLogData;
};

// [{"ItemType":1,"ItemIndex":103,"Count":5000}] -> 아이템명(103): 5000
const formatRewards = (rewards, textList) => {
    const list = typeof rewards === 'string' ? JSON.parse(rewards) : rewards;
    if (!Array.isArray(list)) return rewards ?? '';
    return list
        .map((reward) => {
            const id = reward.ItemIndex ?? reward.id ?? reward.itemId;
            const type = reward.ItemType ?? reward.type ?? reward.itemType;
            const count = reward.Count ?? reward.quantity ?? reward.count;
            return `${getItemName(textList, id, type)}(${id}): ${count}`;
        })
        .join(', ');
};

export const getRankingChallengeLogColumns = (krTextData, currentUser) => {
    return [
        {
            title: '로그 타입',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).logType,
        },
        {
            title: '이벤트 ID',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).eventID,
        },
        {
            title: '세그먼트',
            dataIndex: 'logString',
            render: (logString, record) => parseLogData(logString, record).segment,
        },
        {
            title: '보상',
            dataIndex: 'logString',
            render: (logString, record) => formatRewards(parseLogData(logString, record).rewards, krTextData[currentUser.target]),
            width: '30%',
        },
        {
            title: '트리거 시간',
            dataIndex: 'created',
            render: (created) => created ? fromUnixTimeFormat(created) : '',
        },
    ];
};
